/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Button, InputGroup, Row, Col,
} from 'reactstrap';

import {
  Field, FormikConsumer, ErrorMessage,
} from 'formik';

function IdentifiersFieldset(props) {
  const { arrayHelpers, t } = props;

  const handleAddIdentifier = () => {
    arrayHelpers.push({
      label: '',
      code: '',
      required: true,
    });
  };

  const jsx = (
    <FormikConsumer>
      {({
        // eslint-disable-next-line no-unused-vars
        touched, errors, values, setFieldValue,
      }) => (
        <div>
          <Button color="info" onClick={() => handleAddIdentifier(arrayHelpers)} className="btn-sm btn-soft-info mt-3 mb-3">
            <span className="bx bx-plus" />
            {props.t('Add Identifier')}
          </Button>
          {values.identifiers.map((identifier, index) => (
            <div key={index}>
              <Row className="mt-4">
                <Col xs="6">
                  <InputGroup>
                    <Button
                      type="button"
                      onClick={() => arrayHelpers.remove(index)}
                      color="danger"
                      className="btn-soft-danger"
                    >
                      <span className="mdi mdi-close-thick" />
                    </Button>
                    <Field name={`identifiers[${index}].label`} type="text" className="form-control" placeholder={t('Label')} />
                    <Button
                      type="button"
                      onClick={(e) => {
                        // eslint-disable-next-line eqeqeq
                        setFieldValue(`identifiers[${index}].required`, (values.identifiers[index].required == false));
                        e.target.blur();
                      }}
                      color={values.identifiers[index].required ? 'danger' : 'light'}
                      title={`${values.identifiers[index].required ? t('Required') : t('Not required')}`}
                    >
                      <span className={`mdi mdi-star ${values.identifiers[index].required ? 'mdi-spin' : ''}`} />
                    </Button>
                  </InputGroup>
                  <ErrorMessage
                    name={`identifiers[${index}].label`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>

                <Col xs="6">
                  <Field name={`identifiers[${index}].code`} type="text" className="form-control" placeholder={t('Pre-set Value')} />
                  <ErrorMessage
                    name={`identifiers[${index}].code`}
                    component="div"
                    className="text-danger pt-1"
                  />
                </Col>
              </Row>
            </div>
          ))}
        </div>
      )}
    </FormikConsumer>
  );

  return jsx;
}

IdentifiersFieldset.defaultProps = {
  t: (x) => (x),
};

IdentifiersFieldset.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
  arrayHelpers: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(IdentifiersFieldset));
